export const blockIconsImageControlPoint = (
	<span className='material-symbols-outlined'>control_point</span>
);
